/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CCPaymentInitializeTerminalSale = {
    properties: {
        districtId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        amount: {
            type: 'number',
            isRequired: true,
            format: 'double',
        },
        insightTag: {
            type: 'string',
            isNullable: true,
        },
        custom1: {
            type: 'string',
            isNullable: true,
        },
        custom2: {
            type: 'string',
            isNullable: true,
        },
        custom3: {
            type: 'string',
            isNullable: true,
        },
        custom4: {
            type: 'string',
            isNullable: true,
        },
        manuallyKeyed: {
            type: 'boolean',
        },
        tokenize: {
            type: 'boolean',
        },
    },
};